export default function IconPhone() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 20H4.34113H21" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13 20V3L5.55198 6.6023C5.2165 6.76448 5 7.13168 5 7.5373V20" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20 20V13.9781C20 13.6292 19.8175 13.3035 19.5139 13.1121L13 9" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 10H11" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 13H11" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 16H11" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 16H18" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
